$('.map-block-map').click(function () {
    $('.map-block-map iframe').css('pointer-events', 'auto');
});

$('.map-block-map').mouseleave(function () {
    $('.map-block-map iframe').css('pointer-events', 'none');
});